import moment from 'moment';
import { useEffect, useState } from 'react';
import Dialog from '../../components/dialog/dialog';
import { getEnv } from '../../helpers/mobx-easy-wrapper';
import arrowRight from '../../images/arrow-right.svg';
import trend from '../../images/trend.png';
import { NoticeItem } from '../activity/notice/notice';

const TrendNews = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [category, setCategory] = useState('公告');
  const [data, setData] = useState<Array<NoticeItem>>();
  const [dialogItem, setDialogItem] = useState<NoticeItem>();
  useEffect(() => {
    const { apiFactory } = getEnv();
    async function fetchData() {
      const response = await apiFactory.activityService.getNoticeData(1, '');
      setData(response.items);
    }
    fetchData();
  }, []);

  return (
    <>
      {showDialog && (
        <Dialog
          onClose={() => {
            setShowDialog(false);
          }}
        >
          <div className="fullDialog">
            <div
              className="closeIcon"
              onClick={() => {
                setShowDialog(false);
              }}
            ></div>
            <div className="dialogTitle">{dialogItem?.title}</div>
            <div className="dialogTime">
              {' '}
              {moment(dialogItem?.publishAt).format('YYYY年MM月DD日')}
            </div>
            <div
              className="dialogContent"
              dangerouslySetInnerHTML={{ __html: dialogItem!.content }}
            ></div>
            <div>
              {/*<div className="dialogImg">
                <img src={dialogItem?.thumbnail} />
              </div>*/}
              <div className="buttonArea">
                <button
                  className="closeButton"
                  onClick={() => {
                    setShowDialog(false);
                  }}
                >
                  关闭
                </button>
              </div>
            </div>
          </div>
        </Dialog>
      )}

      <div
        className="jury__line outlineTitle"
        style={{ textAlign: 'center', marginTop: '128px' }}
      >
        <label className={`enter_label  active `}>大赛动态</label>
      </div>
      <div
        className="home-row row-padding"
        style={{ marginTop: '60px', marginBottom: '128px' }}
      >
        <div className="trendCover">
          {/* <img src={data ? data[0].thumbnail : trend} /> */}
          <img src={trend} />
        </div>
        <div className="trendNews">
          {data?.map((item, i) => (
            <div
              key={'trend_' + i}
              className="trendItem"
              onClick={() => {
                const hasExternalUrl = item.hasExternalUrl || false;
                if (hasExternalUrl) {
                  window.open(item.externalUrl, '_blank');
                } else {
                  setDialogItem(item);
                  setShowDialog(true);
                }
              }}
            >
              <div className="title">{item.title}</div>
              <div className="time">
                {moment(item?.publishAt).format('YYYY.MM.DD')}
              </div>
            </div>
          ))}
          <div
            onClick={() => {
              window.location.href = '/trends';
            }}
            className="link-detail container-linkDetail"
            style={{ marginTop: '12px' }}
          >
            <img src={arrowRight} />
            更多动态
          </div>
        </div>
      </div>
    </>
  );
};

export default TrendNews;
